import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import FireIcon from 'src/app/assets/icons/ico-fire.svg'

export type StreakType = 'win' | 'loss'

type Props = Readonly<{
  streakType: StreakType
  streakCount: number
  boostPercent: number
}>

export function StreakIndicator({ streakType, streakCount, boostPercent }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const isWinStreak = streakType === 'win'

  return (
    <div className={`streak-indicator streak-indicator--${streakType}`}>
      <div className="streak-indicator__title">
        <FireIcon />
        <span>
          {isWinStreak ? t('Winning Streak') : t('Comeback Streak')} ({streakCount})
        </span>
      </div>
      <div className="streak-indicator__details">
        {t('+{{percent}}% Boost on next win', { percent: boostPercent })}
      </div>
    </div>
  )
}
